import { render, staticRenderFns } from "./PremiumBblEditor.vue?vue&type=template&id=23a12758&scoped=true"
import script from "./PremiumBblEditor.vue?vue&type=script&lang=js"
export * from "./PremiumBblEditor.vue?vue&type=script&lang=js"
import style0 from "./PremiumBblEditor.vue?vue&type=style&index=0&id=23a12758&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a12758",
  null
  
)

export default component.exports